/**
 * User: Rob Richard
 * Date: 9/5/14
 * Time: 7:14 PM
 */

'use strict';

const get = require('lodash.get');
const has = require('lodash.has');
const SV = require('server-vars');
const qs = require('qs');
const endpoints = require('dibs-endpoints');
const { getBuyerToken } = require('dibs-cookie-jar');
const root = require('./checkout-window-check.es');
let ItemID;

const redirects = (module.exports = {
    setItemId(itemId) {
        ItemID = itemId;
    },
    getKountUrl(itemId, vertical) {
        const kountParams = Object.assign({ itemId, vertical }, getBuyerToken(document.cookie));
        return [endpoints.transactionKount(), qs.stringify(kountParams)].join('?');
    },
    getPathFromUrl(pathName) {
        const pathArray = root.location.pathname.split('/') || [];
        return pathArray.filter(path => path.indexOf(pathName) > -1)[0] || '';
    },
    getItemIdFromUrl() {
        const idStr = 'id-';
        const idPath = redirects.getPathFromUrl(idStr);
        return idPath.replace(idStr, '') || ItemID;
    },
    getParsedQueryKeys() {
        return qs.parse(root.location.search.substr(1));
    },
    hasParamInUrl(param) {
        const params = redirects.getParsedQueryKeys();
        return has(params, param);
    },
    /**
     * get a params value from the URL or Post data (SV)
     * @param param - string property
     * @returns {String|undefined} - if param wasn't found, return undefined
     */
    getParamFromUrl(param) {
        const params = redirects.getParsedQueryKeys();
        return has(params, param) ? params[param] : undefined;
    },
    getCheckoutParam(param) {
        return redirects.getParamFromUrl(param) || SV.get('checkoutPostData.' + param);
    },
    getCheckoutUrl(item = {}) {
        const baseUrl = '/checkout/id-';
        const itemId = item.id || redirects.getItemIdFromUrl();

        if (!itemId) {
            throw new Error(
                'getCheckoutUrl method expects a Backbone model item or to have it in the url.'
            );
        }
        return baseUrl.concat(itemId);
    },
    isBalanceDueByUrl() {
        return !!redirects.getPathFromUrl('balanceDue');
    },
    isUserComesFromEmail() {
        return (
            redirects.getParamFromUrl('utm_medium') === 'email' ||
            redirects.getCheckoutParam('userComesFromEmail') === 'true'
        );
    },
    isUserComesFromAmp() {
        return redirects.getParamFromUrl('userComesFromAmp') === 'true';
    },
    isUserComesFromAcceptedOffer() {
        return (
            redirects.getParamFromUrl('acceptOffer') === 'true' ||
            redirects.getParamFromUrl('fullPrice') === 'true'
        );
    },
    isUserNegotiating() {
        return !!redirects.getParamFromUrl('offerAmount');
    },
    hasAllowWireTransferInUrl() {
        // when allowWireTransfer=true is part of the uri params, allow checkout with wire transfer - MONEY-2591.
        return redirects.getParamFromUrl('allowWireTransfer') === 'true';
    },
    hasAllowCheckInUrl() {
        // when allowCheck=true is part of the uri params, allow checkout with check - MONEY-4358.
        return redirects.getParamFromUrl('allowCheck') === 'true';
    },

    // use wrapper for easier spying when testing
    redirect(url) {
        // we actually want to go somewhere now, make sure
        // the warning is turned off
        root.onbeforeunload = null;
        root.location.href = url;
    },
    getPostData(transaction, error) {
        const offer = transaction.getMostRecentOffer();
        const promo = transaction.getActivePromo();
        const data = {
            message: offer && offer.get('notes[0].content'),
            quantity: offer && offer.get('quantity'),
            shippingAddress:
                transaction.get('shipment.shippingAddress.sourceId') ||
                transaction.get('shipment.shippingAddress.id'),
            promoCode: promo && promo.get('code'),
            error,
        };

        if (transaction.isNegotiable()) {
            data.offerAmount = offer && offer.get('amountPerItem.amount');
            data.offerCurrency = offer && offer.get('amountPerItem.currency');
        }
        return data;
    },
    goToMessageCenter(buyerId) {
        const itemId = redirects.getItemIdFromUrl();
        if (itemId && buyerId) {
            redirects.redirect(`/my/conversations/buyer/${buyerId}/item/${itemId}`);
        } else {
            redirects.redirect('/');
        }
    },
    goToPDP() {
        const url = `/id-${redirects.getItemIdFromUrl()}/`;
        redirects.redirect(url);
    },
    goToConfirmation(transactionId) {
        const itemId = redirects.getItemIdFromUrl();
        const url = `/checkout/confirmation/id-${itemId}/${transactionId}`;
        redirects.redirect(url);
    },
    goToOMT(id) {
        let url = '/my/orders/';
        if (id) {
            url = url.concat(`order/${id}`);
        }
        redirects.redirect(url);
    },
    goToItemCategory(item) {
        const categories = get(item, 'classification.categories', []);
        const url = get(categories[0], 'category.browseUrl', '/');
        redirects.redirect(url);
    },
    hasAllowCheckInUrl() {
        // when allowCheck=true is part of the uri params, allow checkout with check - MONEY-4358.
        return redirects.getParamFromUrl('allowCheck') === 'true';
    },
});



// WEBPACK FOOTER //
// ./assets/js/checkout/helpers/checkout-redirects.es.js